module.exports = __webpack_public_path__ + "files/a2fe8019aff86724e29afa309075c758.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./images/webhook_icon.jpg
 ** module id = 388
 ** module chunks = 0
 **/